import trustImage from '../images/whyUs/trust.png'
import responsiveImage from '../images/whyUs/responsive.png'
import memorableImage from '../images/whyUs/memorable.png'


export const whyUsData = [
    {   
        image: trustImage,
        title: "Trusted Advisor",
        body: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.",
        borderClass: "whyUsCard__green"
    },
    {
        image: responsiveImage,
        title: "Responsive Packages",
        body: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
        borderClass: "whyUsCard__purple"
    },
    {
        image: memorableImage,
        title: "Memorable Experiences",
        body: "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.",
        borderClass: "whyUsCard__red"
    }
]